<sim-basic-material-dialog
	(closeClicked)="close({user: null, action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontIcon: 'fa-user', fontSet: 'fas'}"
	[headerText]="T.ADD_AD_HOC_DIALOG_CREATE_USER | translate"
	class="normalDuotoneHeaderIcon"
>
	<div dialogContent>
		<div class="bottom">
			<form [formGroup]="adHocUserFormGroup">
				<mat-form-field class="full-width-form" color="accent">
					<input formControlName="firstNameControl" matInput placeholder="Firstname" required />
					@if (adHocUserFormGroup.controls.firstNameControl.hasError("required")) {
						<mat-error>
							{{ T.ADD_AD_HOC_DIALOG_ERROR_MESSAGE_REQUIRED_FIRSTNAME | translate }}
						</mat-error>
					}
				</mat-form-field>
				<mat-form-field class="full-width-form" color="accent">
					<input formControlName="lastNameControl" matInput placeholder="Lastname" required />
					@if (adHocUserFormGroup.controls.lastNameControl.hasError("required")) {
						<mat-error>
							{{ T.ADD_AD_HOC_DIALOG_ERROR_MESSAGE_REQUIRED_LASTNAME | translate }}
						</mat-error>
					}
				</mat-form-field>
				@if (createUserError != null) {
					<mat-error id="general-error">{{ createUserError }}</mat-error>
				}
			</form>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({user: null, action: 'cancel'})"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[color]="'warn'"
			[label]="T.BUTTON_CANCEL"
		/>

		<sim-button
			(onClick)="createUser()"
			[disabled]="!adHocUserFormGroup.valid"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[color]="'accent'"
			[label]="T.BUTTON_CREATE"
		/>
	</ng-container>
</sim-basic-material-dialog>
